$(function(){
  // snow.js
  function createSnow(canvasId, options) {
      const canvas = document.getElementById(canvasId);
      const ctx = canvas.getContext('2d');
      const { snowflakeCount, snowflakeColor, fallSpeed } = options;
   
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
   
      const snowflakes = [];
   
      for (let i = 0; i < snowflakeCount; i++) {
          snowflakes.push({
              x: Math.random() * canvas.width,
              y: Math.random() * canvas.height,
              size: Math.random() * 5,
              speed: Math.random() * fallSpeed + 1
          });
      }
   
      function renderSnow() {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
   
          snowflakes.forEach((flake) => {
              ctx.beginPath();
              ctx.fillStyle = snowflakeColor;
              ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
              ctx.fill();
   
              flake.y += flake.speed;
              if (flake.y > canvas.height) {
                  flake.y = 0;
              }
          });
      }
      setInterval(renderSnow, 28);
  }

  let currentPage = window.location.href
  if(currentPage.search("christmas-sale-2024")!=-1){
    // 鼠标变圣诞树
    $("*").css("cursor",'url(https://cdn.shopify.com/s/files/1/0508/1815/4652/files/icon_87f6e717-3d9a-42d0-88f1-1b818e887f36.svg?v=1733370659)10 10,auto')

    
    $("main").append(`<canvas id="snowCanvas"></canvas>`)
	// 下雪
    setTimeout(()=>{
		createSnow('snowCanvas', {
    	    snowflakeCount: 100,
    	    snowflakeColor: 'white',
    	    fallSpeed: 1.5
    	});
	},1000)
  }

  // 情人节爱心飘落动画
  function createHeart() {
      const heart = $('<div>').addClass('heart');
      const startLeft = Math.random() * $(window).width();
      const animationDuration = Math.random() * 5 + 5; // 5 to 10 seconds

      heart.css({
          left: startLeft,
          animationDuration: animationDuration + 's'
      });

      $('#hearts-container').append(heart);

      setTimeout(() => {
          heart.remove();
      }, animationDuration * 2000);
  }
  if(currentPage.search("autel-robotics-drones-valentines-day-sale-2025")!=-1){
    $("body").append(`<div id="hearts-container"></div>`).css("overflow-x","hidden")
    setInterval(createHeart, 1200);
  }
  
})